<template>
  <div></div>
</template>
<script>
export default {
  name: 'corporationBackground',

  computed:{
    backgroundImageUrl() {return this.$store.getters['corporationSettingsState/backgroundImageUrl'];},
    backgroundTransparencyPercent() {return this.$store.getters['corporationSettingsState/backgroundTransparencyPercent'];},

  },
  watch:{
    backgroundImageUrl(){
      this.updateBackgroundImage();
    },
    backgroundTransparencyPercent(){
      this.updateBackgroundImage();
    },
  },
  methods: {
    updateBackgroundImage() {
      let background = 'unset';
      let opacity = 'unset';
      if (this.backgroundImageUrl) {
        background = 'url(\'' + this.backgroundImageUrl + '\')';
      }

      if (this.backgroundTransparencyPercent || this.backgroundTransparencyPercent === 0) {
        opacity = 1.0 - this.backgroundTransparencyPercent/100.0;
      }

      document.querySelector(':root').style.setProperty('--corporation-settings-background-image-url', background);
      document.querySelector(':root').style.setProperty('--corporation-settings-background-image-opacity', opacity);
    },
  },

  mounted() {
    this.updateBackgroundImage();
  },
};
</script>

